import { createSlice } from "@reduxjs/toolkit";
import {
  fetchBranchTransferReceiveList,
  fetchBranches,
} from "./branchTransferReceiveThunk";

const branchTransferReceiveSlice = createSlice({
  name: "branchTransferReceive",
  initialState: {
    list: [],
    branches: [],
    branchLoading: false,
    filters: {
      filterType: "All",
      fromBranchId: null,
      fromDate: null,
      toDate: null,
    },
    loading: false,
    error: null,
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetList: (state) => {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranchTransferReceiveList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranchTransferReceiveList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchBranchTransferReceiveList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchBranches.pending, (state) => {
        state.branchLoading = true;
      })
      .addCase(fetchBranches.fulfilled, (state, action) => {
        state.branchLoading = false;
        state.branches = action.payload;
      })
      .addCase(fetchBranches.rejected, (state) => {
        state.branchLoading = false;
        state.branches = [];
      });
  },
});

export const { setFilters, resetList } = branchTransferReceiveSlice.actions;
export default branchTransferReceiveSlice.reducer;
